import HelpItemAreasMenu from '@/components/HelpCenter/HelpItemAreasMenu';
import { useDisclosure } from '@/hooks';
import { Typography } from 'antd';
import { ChevronRight, X } from 'react-feather';

import './style.less';
import { useLayoutEffect } from 'react';

const HelpItemAside: React.FC = () => {
  const [menuOpen, { toggle: menuToggle }] = useDisclosure(false);

  useLayoutEffect(() => {
    if (menuOpen) {
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'relative';
    }
  }, [menuOpen]);

  return (
    <div className="help-item-aside">
      <div className="help-item-aside-action">
        <button onClick={menuToggle}>
          <span>Módulos relacionados</span>
          <ChevronRight size={16} />
        </button>
      </div>

      <div className="help-item-aside-content" data-open={menuOpen}>
        <div className="help-item-aside-header">
          <Typography.Title level={3} style={{ margin: 0 }}>
            Módulos
          </Typography.Title>

          <button className="help-item-aside-header-close" onClick={menuToggle}>
            <X size={16} />
          </button>
        </div>

        <HelpItemAreasMenu />
      </div>
    </div>
  );
};

export default HelpItemAside;
